
export default [
  {
    path: '/playground',
    component: () => import('@/views/Playground/Index'),
    name: 'Playground',
    meta: {
      title: '演练',
      noCache: true,
      affix: true
    }
  },
  {
    path: '/playground/animate',
    component: () => import('@/views/Playground/Animate'),
    name: 'PlaygroundAnimate',
    meta: {
      title: '演练动画',
      noCache: true,
      affix: true
    }
  }
]
